<template>
  <section class="section container pt-3">
    <div class="title is-4">{{ $t("core") }}</div>
    <div class="tabs is-toggle is-fullwidth" ref="tabs">
      <ul>
        <li
          class="is-active"
          data-tab="system_log"
          @click="change_active_tab($event, this)"
        >
          <a>
            <i class="list icon" aria-hidden="true"></i>
            <span>{{ $t("system log") }}</span>
          </a>
        </li>
        <li data-tab="enterprises" @click="change_active_tab($event, this)">
          <a>
            <i class="building icon" aria-hidden="true"></i>
            <span>{{ $t("enterprises") }}</span>
          </a>
        </li>
        <li data-tab="file" @click="change_active_tab($event, this)">
          <a>
            <i class="cogs icon" aria-hidden="true"></i>
            <span>{{ $t("configuration") }}</span>
          </a>
        </li>
        <li data-tab="backups" @click="change_active_tab($event, this)">
          <a>
            <i class="time icon" aria-hidden="true"></i>
            <span>{{ $t("backups") }}</span>
          </a>
        </li>
      </ul>
    </div>
    <div class="is-fluid" ref="contents">
      <div class="" data-tab="system_log"><log /></div>
      <div class="is-hidden" data-tab="enterprises"><enterprises /></div>
      <div class="is-hidden" data-tab="file"><config /></div>
      <div class="is-hidden" data-tab="backups"><backups /></div>
    </div>
  </section>
</template>

<script>
import { get_configuration, change_active_tab } from "@/utils";
import Enterprises from "./enterprises/Index.vue";
import Config from "./config_file/Index.vue";
import Log from "./log/Index.vue";
import Backups from "./backups/Index.vue";

export default {
  name: "SystemIndex",
  components: { Enterprises, Config, Log, Backups },
  data() {
    return {
      is_loading: false,
      module_settings: {},
    };
  },
  methods: {
    change_active_tab,
    retrieve_settings() {
      let v = this;
      get_configuration(this)
        .then((conf) => {
          v.module_settings = conf;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    create() {},
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {
    this.retrieve_settings();
  },
  created() {},
};
</script>

<style scoped></style>
